"use client"
import { createContext, useCallback, useContext, type ReactNode } from "react"
import { mediaUrl, type MediaKey } from "@/lib/media"
import type { SiteImageOverride } from "./site-images"

type Overrides = Record<string,SiteImageOverride>
const Context = createContext<Overrides>({})
export function SiteImagesProvider({ images, children }: { images: Overrides; children: ReactNode }) {
  return <Context value={images}>{children}</Context>
}
export const useSiteImages = () => useContext(Context)
export function useSiteMediaUrl() {
  const images = useSiteImages()
  return useCallback((key: MediaKey) => {
    const original = mediaUrl(key)
    return images[original]?.src || original
  }, [images])
}
